<template>
  <div id="app">
    <!--Aqui irá o sitemap-->

    <component v-bind:is="layout">
      <template slot="toolbar-title">
        <v-toolbar-title style="cursor: pointer" color="accent" class="pl-3 pr-2" data-cy="toolbar-title">Cyber Switch</v-toolbar-title>
      </template>
    </component>

    <notifications group="notifications-bottom-right" position="bottom right" classes="custom-notification" />

    <BlockUI v-if="loading" id="ui-loader-1234">
      <v-progress-circular indeterminate size="64" />
    </BlockUI>
  </div>
</template>
<script>
import 'shared/styles/variables.scss'
// layout em branco da página index
import IndexLayout from '@bmp-vue/core/layouts/IndexLayout'

// layout do sistema
import AppLayout from '@bmp-vue/core/layouts/AppLayout'

export default {
  name: 'App',
  components: {
    AppLayout,
  }, 
  metaInfo: {
    title: '',
    titleTemplate: 'Money Plus - %s'
  },
  data() {
    return {
      isLoaded: false,
      signedIn: false
    }
  },
  computed: {
    loading() {
      return this.$store.getters.loading || this.$store.getters.activeRequests > 0
    },
    layout() {
      this.$store.commit('SET_LAYOUT', IndexLayout)
      if (!this.$route.meta.anonymousAuth && ['/'].indexOf(this.$route.path) < 0) {
        this.$store.commit('SET_LAYOUT', AppLayout)
      }

      return this.$store.getters.layout
    }
  },
  mounted() {
    var vm = this

    vm.$store.commit('isMobile')
    if (!vm.$store.getters.isMobile) { vm.$store.commit('drawer') }

    window.addEventListener('resize', function () {
      vm.$store.commit('isMobile')
    })
  },
  methods: {
    verificar: function () {
      var vm = this
      setTimeout(function () {
        if (!vm.loading && vm.signedIn) { vm.isLoaded = true } else { vm.verificar() }
      }, 10)
    }
  }
}
</script>
